module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAABW0lEQVRYhe3Wv08TcRjHcX4tEpMyFN1cmWqIKYGFRWcndWDjP+iOi/FfYCXGyY2Bha1DBzZYqQn8A5hOTapo0JdDn5Kmv7C5Xi8m3/dyd5/v832e910ul1tYSCQSiUQikTfYxZVs3OBtnpIb6GSU7HGHV3mJHkGcDx0nMaIXNPISvR86rShKI3p1/hfRoSedq+i/MKlXbqIT+IljfMRntKe9gXmIfsPmQP0zfC1StNKX9UTejNmzhT/4jkeRleYq2jfwB1Ym7GtGXbUo0Sdx3X5g33nU7RQluohWZC/G7CnjFr+xXohoZIeRnWF1oH4ZX2K93pcXIvpU9ycDLrGPbbxDI/IOnhcqGnkF10bTwsuB+mJEY+0xajjFBep4j/KI2rmJVjP2WYs+v2blNjjgJAZ8yNhnL/o0Z6Q2NOB1DLgb8z5OSy0X0ZA90P0mZuUTlnITTSQSiUQi0eMvcdd9y43891cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico-istagram.png
// module id = qjTZ
// module chunks = 1